import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { STEPS_LABELS } from './constants';
import { setCurrentStep } from './store/actions/stepper';
import Run from './run/run';

export function NewImportRun({ setCurrentStep }) {

  useEffect(() => {
    setCurrentStep(STEPS_LABELS.RUN);
  }, []);

  return <Run />;
}

NewImportRun.propTypes = {
  setCurrentStep: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  setCurrentStep
};

export default connect(null, mapDispatchToProps)(NewImportRun);
